import type { ReactNode } from "react";
import { ApiError } from "../lib/api";
import EmptyState, { emptyStateActionClass } from "./EmptyState";

/** Only confirmed HTTP outcomes explain access/not-found; other failures retry. */
export default function DataRecovery({ error, subject, onRetry, back, missing = false }: {
  error: unknown; subject: string; onRetry: () => void; back?: ReactNode; missing?: boolean;
}) {
  const status = error instanceof ApiError ? error.status : null;
  const denied = status === 403 || status === 401;
  const notFound = missing && status === 404;
  return <EmptyState alert title={denied ? "Zugriff nicht möglich" : notFound ? "Angebot nicht verfügbar" : `${subject} konnten nicht geladen werden`} actions={<>
    {!notFound && <button className={emptyStateActionClass} onClick={onRetry}>Erneut versuchen</button>}{back}
  </>}>
    {denied ? "Du kannst diese Daten mit deinem aktuellen Zugriff nicht öffnen. Wende dich bei Bedarf an die Verwaltung deines Arbeitsbereichs." : notFound ? "Dieses Angebot ist über den geöffneten Link nicht verfügbar. In der Angebotsliste kannst du ein anderes auswählen." : "Bitte versuche es erneut. Daraus lässt sich nicht ableiten, dass keine Daten vorhanden sind."}
  </EmptyState>;
}
